import React from "react";
import Textarea from "react-textarea-autosize";
import classNames from "classnames";
import PropTypes from "prop-types";

import styles from "./ExpandingTextarea.css";
import errorStyles from "validation.css";

export default function ExpandingTextarea(props) {
  return (
    <label>
      <Textarea
        className={classNames(styles.root, props.className, {
          [errorStyles.hasError]: !!props.error,
        })}
        style={{ fontSize: 13, paddingTop: 15, paddingBottom: 15 }}
        aria-invalid={!!props.error}
        {...props}
      />
      {!!props.error && (
        <span className={errorStyles.errorText}>
          {props.error.message || props.error}
        </span>
      )}
    </label>
  );
}

ExpandingTextarea.propTypes = {
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.instanceOf(Error),
  ]),
};
